export default [
    {
        path: '/pick/dynamic/overview',
        name: 'pick_dynamic_overview',
        component: () => import('@src/pick/dynamic/overview.vue'),
        meta: {
            title: 'Dynamisches Picken',
            role: 'ROLE_PICK_DYNAMIC',
        },
    },
    {
        path: '/pick/dynamic/pick-entry',
        name: 'pick_dynamic_pick_entry',
        component: () => import('@src/pick/dynamic/pick-entry.vue'),
        meta: {
            title: 'Dynamisches Picken',
            role: 'ROLE_PICK_DYNAMIC',
        },
    },
    {
        path: '/settings/pick/single-ship-product',
        name: 'settings_single_ship_product',
        component: () => import('@src/pick/pick-settings/single-ship-product.vue'),
        meta: {
            title: 'Einzeln zu verschickende Artikel',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/settings/pick/adjust-finish-date/weekday',
        name: 'setting_adjust_finish_date_weekday',
        component: () => import('@src/pick/pick-settings/adjust-finish-date-weekday.vue'),
        meta: {
            title: 'Abschlussdatum anpassen (Wochentage)',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/settings/pick/warehouse-users/user-overview',
        name: 'settings_warehouse_users_warehouses_overview',
        component: () => import('@src/pick/pick-settings/user-overview.vue'),
        meta: {
            title: 'Mitarbeiter zu Picklager zuordnen',
            role: 'ROLE_EDIT_USER_WAREHOUSE_SETTINGS',
        },
    },
    {
        path: '/settings/pick/blocked-pick-queue-warehouse-groups',
        name: 'settings_blocked_pick_queue_warehouse_groups',
        component: () => import('@src/pick/pick-settings/blocked-pick-queue-warehouse-groups.vue'),
        meta: {
            title: 'Blockierte Lagergruppen',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/settings/pick/assigned-boxes-to-request-in-box',
        name: 'settings_assigned_boxes_to_request_in_box',
        component: () => import('@src/pick/pick-settings/assigned-boxes-request-in-box.vue'),
        meta: {
            title: 'Gewünschte Boxenauslastung',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/settings/pick/not-found-price',
        name: 'settings_not_found_price',
        component: () => import('@src/pick/pick-settings/not-found-check.vue'),
        meta: {
            title: 'Überprüfung nicht gefundener Artikel',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/settings/pick/age-pick-queue-prioritize',
        name: 'settings_age_pick_queue_prioritize',
        component: () => import('@src/pick/pick-settings/age-pick-queue-prioritize.vue'),
        meta: {
            title: 'Dauer bis Artikel Priorität bekommen',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/settings/pick/number-of-products-recommend-in-box',
        name: 'settings_number_of_products_recommend_in_box',
        component: () => import('@src/pick/pick-settings/number-of-products-recommend-in-box.vue'),
        meta: {
            title: 'Anzahl gepickter Artikel zum Einboxen',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/settings/pick/blocked-product-group-time-interval',
        name: 'settings_blocked_product_group_time_interval',
        component: () => import('@src/pick/pick-settings/blocked-product-group-time-interval.vue'),
        meta: {
            title: 'Produktgruppen vom Picken ausschließen',
            role: 'ROLE_EDIT_DYNAMIC_PICK_SETTINGS',
        },
    },
    {
        path: '/pick/one-bin-warehouse/filter/overview',
        name: 'one_bin_warehouse_filter_overview',
        component: () => import('@src/pick/one-bin-warehouse/pick-filter-overview.vue'),
        meta: {
            title: 'Picklistenfilter',
            role: 'ROLE_LIST_ONE_BIN_WAREHOUSE_PICK_FILTER',
        },
    },
    {
        path: '/pick/one-bin-warehouse/filter/create',
        name: 'one_bin_warehouse_filter_create',
        component: () => import('@src/pick/one-bin-warehouse/pick-filter-create.vue'),
        meta: {
            title: 'Picklistenfilter anlegen',
            role: 'ROLE_EDIT_ONE_BIN_WAREHOUSE_PICK_FILTER',
        },
    },
    {
        path: '/pick/dynamic/user-list',
        name: 'pick_dynamic_user-list',
        component: () => import('@src/pick/dynamic/user-list.vue'),
        meta: {
            title: 'Aktuell pickende Benutzer',
            role: 'ROLE_LIST_DYNAMIC_PICK_USER',
        },
    },
    {
        path: '/pick/one-bin-warehouse/filter/edit/:id',
        name: 'one_bin_warehouse_filter_edit',
        component: () => import('@src/pick/one-bin-warehouse/pick-filter-edit.vue'),
        meta: {
            title: 'Picklistenfilter bearbeiten',
            role: 'ROLE_EDIT_ONE_BIN_WAREHOUSE_PICK_FILTER',
        },
        props(route: any) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
    },
    {
        path: '/pick/one-bin-warehouse/pick-list/:idFilter?',
        name: 'one_bin_warehouse_pick_list',
        component: () => import('@src/pick/one-bin-warehouse/pick-list.vue'),
        meta: {
            title: 'Pickliste',
            role: 'ROLE_SHOW_ONE_BIN_WAREHOUSE_PICK_LIST',
        },
        props(route: any) {
            return { idFilter: route.params.idFilter ? Number.parseInt(route.params.idFilter) : null };
        },
    },
    {
        path: '/pick/not-found/list',
        name: 'pick_not_found_list',
        component: () => import('@src/pick/not-found/not-found-list.vue'),
        meta: {
            title: 'Liste nicht gefundener Artikel',
            role: 'ROLE_SHOW_PICK_NOT_FOUND_LIST',
        },
    },
    {
        path: '/pick/one-bin-warehouse/not-found/list',
        name: 'pick_one_bin_warehouse_not_found_list',
        component: () => import('@src/pick/one-bin-warehouse/one-bin-warehouse-not-found-list.vue'),
        meta: {
            title: 'Liste nicht gefundener Artikel',
            role: 'ROLE_ONE_BIN_WAREHOUSE_PICK_NOT_FOUND',
        },
    },
    {
        path: '/picking-cart/list',
        name: 'picking_cart_list',
        component: () => import('@src/pick/picking-cart/overview.vue'),
        meta: {
            title: 'Pickwagenübersicht',
            role: 'ROLE_LIST_PICKING_CART',
        },
    },
    {
        path: '/picking-cart/create',
        name: 'picking_cart_create',
        component: () => import('@src/pick/picking-cart/create.vue'),
        meta: {
            title: 'Pickwagen anlegen',
            role: 'ROLE_EDIT_PICKING_CART',
        },
    },
    {
        path: '/picking-cart/show/:id',
        name: 'picking_cart_show',
        component: () => import('@src/pick/picking-cart/show.vue'),
        meta: {
            title: 'Pickwagen anzeigen',
            role: 'ROLE_SHOW_PICKING_CART',
        },
        props(route: any) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
    },
    {
        path: '/pick/dashboard',
        name: 'pick_dashboard',
        component: () => import('@src/pick/pick-dashboard/pick-dashboard.vue'),
        meta: {
            title: 'Dashboard',
            role: 'ROLE_PICK_DASHBOARD',
        },
    },
    {
        path: '/pick/docs/:tab?',
        name: 'pick_docs',
        component: () => import('@src/pick/docs/pick-docs.vue'),
        meta: {
            title: 'Hilfe',
            role: 'ROLE_PICK_DOCS',
        },
    },
];
